import React from "react";

import { Section, SectionTitle } from "../../../../App/Common/Styles/containers";
import { ILocalizedMessageApi } from "../../../../reducers/course-author/types";
import { PreferredLocale } from "../../../../utils/locales";
import { ICourseEditOperations, IFullCourse } from "../../../course-author/types";
import EditCourseCompletionMessage from "./EditCourseCompletionMessage";
import EditCourseDescription from "./EditCourseDescription";
import EnforceLinearProgression from "./EnforceLinearProgression";

interface ICourseSetup {
  course: IFullCourse;
  currentLocale: PreferredLocale;
  editOperations: ICourseEditOperations;
  localizedMessageApi: ILocalizedMessageApi;
}

const CourseSetup: React.FC<ICourseSetup> = props => {
  const { course, currentLocale, editOperations, localizedMessageApi } = props;
  return (
    <Section>
      <SectionTitle>Course Setup</SectionTitle>
      <EditCourseDescription course={course} currentLocale={currentLocale} editOperations={editOperations} />
      <EnforceLinearProgression course={course} editOperations={editOperations} />
      <EditCourseCompletionMessage
        course={course}
        currentLocale={currentLocale}
        editOperations={editOperations}
        localizedMessageApi={localizedMessageApi}
      />
    </Section>
  );
};

export default CourseSetup;
